
export default {
  data() {
    return {
      isScrolled: false,
      hideComponent: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const footer = document.getElementById("footer");
      const footerTop = footer.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Check if user has scrolled past a certain point
      this.isScrolled = window.scrollY > 100;

      // Check if footer is within the viewport
      this.hideComponent = footerTop <= windowHeight;
    },
  },
};

